import { gql } from '@apollo/client';

export const EVENTS = gql`
    query events(
        $search: String
        $sort: EventSortEnum
        $offset: Int
        $first: Int
        $type: [EventType]
        $status: [EventStatus]
        $isFullCapacity: Boolean
    ) {
        events(
            search: $search
            sort: $sort
            offset: $offset
            first: $first
            type_In: $type
            status_In: $status
            isFullCapacity: $isFullCapacity
        ) {
            pageInfo {
                hasNextPage
            }
            edges {
                node {
                    id
                    type
                    name
                    date
                    status
                    fromTime
                    untilTime
                    allDay
                    capacity
                    confirmed {
                        totalCount
                    }
                    invited(first: 10) {
                        totalCount
                        edges {
                            node {
                                id
                                firstName
                                lastName
                                image {
                                    url
                                }
                            }
                        }
                    }
                    numberOfConfirmed
                    numberOfGuests
                    totalNumberOfInvitees
                }
            }
            totalCount
        }
    }
`;

export const EVENT = gql`
    query event($id: ID!) {
        event(id: $id) {
            id
            name
            date
            type
            status
            fromTime
            untilTime
            allDay
            capacity
            description
            comments
            confirmed(first: 100) {
                totalCount
                pageInfo {
                    hasNextPage
                    endCursor
                }
                edges {
                    node {
                        id
                        firstName
                        lastName
                        image {
                            url
                        }
                        invitedGuests(first: 100, event: $id) {
                            edges {
                                node {
                                    id
                                    name
                                    email
                                }
                            }
                        }
                    }
                }
            }
            invited(first: 100) {
                totalCount
                pageInfo {
                    hasNextPage
                    endCursor
                }
                edges {
                    node {
                        id
                        firstName
                        lastName
                        image {
                            url
                        }
                        invitedGuests(first: 100, event: $id) {
                            edges {
                                node {
                                    id
                                    name
                                    email
                                }
                            }
                        }
                    }
                }
            }
            images {
                id
                image {
                    url
                    alt
                }
            }
            documents {
                id
                name
                document {
                    url
                }
            }
        }
    }
`;

export const EVENT_CONFIRMED_MEMBERS = gql`
    query eventConfirmedMembers($id: ID!, $after: String) {
        event(id: $id) {
            id
            confirmed(first: 100, after: $after) {
                totalCount
                pageInfo {
                    hasNextPage
                    endCursor
                }
                edges {
                    node {
                        id
                        firstName
                        lastName
                        image {
                            url
                        }
                        invitedGuests(first: 100, event: $id) {
                            edges {
                                node {
                                    id
                                    name
                                    email
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;

export const EVENT_INVITED_MEMBERS = gql`
    query eventInvitedMembers($id: ID!, $after: String) {
        event(id: $id) {
            id
            invited(first: 100, after: $after) {
                totalCount
                pageInfo {
                    hasNextPage
                    endCursor
                }
                edges {
                    node {
                        id
                        firstName
                        lastName
                        image {
                            url
                        }
                        invitedGuests(first: 100, event: $id) {
                            edges {
                                node {
                                    id
                                    name
                                    email
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;
